import React, { useEffect, useState } from "react";

import {
  ScrollArea,
  Avatar,
  AvatarImage,
  useToast,
  Switch,
} from "../../components/ui";
import constant, { statuses } from "../../constants";
import { FaPlus } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { Header } from "../../components/modules";
import { FaTimes, FaCheckCircle } from "react-icons/fa";
import Context from "../../Context";
import { IoMdTrash } from "react-icons/io";

import { Spinner } from "reactstrap";
import { useParams } from "react-router-dom";
import { RiLockPasswordLine } from "react-icons/ri";

import th from "antd/es/date-picker/locale/th_TH";
import dayTh from "dayjs/locale/th";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import { DatePicker } from "antd";

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

const buddhistLocale = {
  ...th,
  lang: {
    ...th.lang,
    fieldDateFormat: "DD-MM-BBBB",
    fieldDateTimeFormat: "DD-MM-BBBB HH:mm:ss",
    yearFormat: "BBBB",
    cellYearFormat: "BBBB",
  },
};

export const UserCreate = () => {
  const { toast } = useToast();
  const { userId } = useParams();
  const { callApi, navigate } = Context();
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {}, []);

  const createUser = async () => {
    setLoading(true);
    const { status, data, toastMessage } = await callApi(
      "users-adminCreateUser",
      {
        user,
      },
      {
        notShowLoading: true,
      },
    );
    toast({
      className: status ? "bg-[rgb(59,176,101)]" : "bg-[#c15b78]",
      title: (
        <div className="flex gap-2 items-center">
          {status ? <FaCheckCircle /> : <FaTimes />}
          {status
            ? "สร้างบัญชีใหม่สำเร็จ"
            : toastMessage || "สร้างบัญชีใหม่ไม่สำเร็จ"}
        </div>
      ),
    });
    if (status) {
      setUser({});
    } else {
    }

    setLoading(false);
  };

  return (
    <div className="h-fit w-full min-w-[1024px] max-w-[1600px] no-scrollbar mx-auto">
      {/* header */}
      <Header
        header="Users"
        subHeader={`สร้างบัญชีผู้ใช้ใหม่`}
        icon={<FiUsers className="text-blue" />}
      />
      {/* <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-[#E5E7E9] overflow-hidden">
        <div className="flex items-center gap-4 p-3 border-b border-[#E5E7E9]">
          <p className="font-semibold text-xl">ข้อมูลส่วนตัว</p>
        </div> */}
      <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-[#E5E7E9] overflow-hidden">
        <div className="flex items-center p-3 border-b border-[#E5E7E9] justify-between">
          <p className="font-semibold text-xl">สร้างบัญชีผู้ใช้ใหม่</p>
        </div>
        <div className="grid grid-cols-3 p-3 gap-2 ">
          {loading && (
            <div className="absolute w-full z-50 h-full bg-[rgb(255,255,255,0.6)] flex items-center justify-center">
              <Spinner className="w-4 h-4" />
            </div>
          )}
          <div className="row-span-3 relative mt-2 h-fit flex justify-center items-center">
            <Avatar className={"w-full h-full max-w-52 max-h-52 duration-150"}>
              <AvatarImage
                src={user?.profileImage || "https://github.com/shadcn.png"}
              />
            </Avatar>
          </div>

          <div>
            <p className="font-semibold text-sm text-gray-500">ชื่อ</p>
            <div className="flex">
              <input
                className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
                type="text"
                disabled={loading}
                defaultValue={user?.firstName}
                onChange={(e) => {
                  setUser((prevState) => ({
                    ...prevState,
                    firstName: e.target.value,
                  }));
                }}
                // onBlur={(e) => updateUser("lastName", e.target.value)}
                placeholder="ชื่อ"
              />
            </div>
          </div>
          <div>
            <p className="font-semibold text-sm text-gray-500">นามสกุล</p>
            <div className="flex">
              <input
                className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
                type="text"
                disabled={loading}
                value={user?.lastName}
                onChange={(e) => {
                  setUser((prevState) => ({
                    ...prevState,
                    lastName: e.target.value,
                  }));
                }}
                placeholder="นามสกุล"
              />
            </div>
          </div>
          <div>
            <p className="font-semibold text-sm text-gray-500">
              ชื่อ (ภาษาอังกฤษ)
            </p>
            <div className="flex">
              <input
                className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
                type="text"
                disabled={loading}
                value={user?.firstNameEn}
                onChange={(e) => {
                  setUser((prevState) => ({
                    ...prevState,
                    firstNameEn: e.target.value,
                  }));
                }}
                // onBlur={(e) => updateUser("lastName", e.target.value)}
                placeholder="ชื่อ (ภาษาอังกฤษ)"
              />
            </div>
          </div>
          <div>
            <p className="font-semibold text-sm text-gray-500">
              นามสกุล (ภาษาอังกฤษ)
            </p>
            <div className="flex">
              <input
                className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
                type="text"
                disabled={loading}
                value={user?.lastNameEn}
                onChange={(e) => {
                  setUser((prevState) => ({
                    ...prevState,
                    lastNameEn: e.target.value,
                  }));
                }}
                // onBlur={(e) => updateUser("lastName", e.target.value)}
                placeholder="นามสกุล (ภาษาอังกฤษ)"
              />
            </div>
          </div>

          <div className="col-span-2">
            <p className="font-semibold text-sm text-gray-500">
              ที่อยู่ (ตามบัตรปชช)
            </p>
            <div className="flex">
              <textarea
                className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
                type="text"
                value={user?.address?.addrId}
                disabled={loading}
                onChange={(e) => {
                  setUser((prevState) => ({
                    ...prevState,
                    address: { ...prevState.address, addrId: e.target.value },
                  }));
                }}
                placeholder="ที่อยู่ (ตามบัตรปชช)"
              />
            </div>
          </div>
          <div
            className={`${
              user?.verifiedId === statuses.VERIFIED
                ? "bg-green"
                : "bg-gray-300"
            } text-white rounded-md flex mx-auto hover:opacity-85 duration-150 items-center h-fit mt-auto w-56 px-3 py-2.5 gap-3 cursor-pointer`}
          >
            <div className="">
              <Switch
                checked={user?.verifiedId === statuses.VERIFIED}
                onCheckedChange={async (e) => {
                  setUser((prevState) => ({
                    ...prevState,
                    verifiedId: e ? statuses.VERIFIED : false,
                  }));
                }}
              />
            </div>
            <p className="font-semibold text-sm">ยืนยันบัตรประชาชนแล้ว</p>
          </div>
          <div>
            <p className="font-semibold text-sm text-gray-500">
              จังหวัด (ตามบัตรปชช)
            </p>
            <div className="flex">
              <select
                className="border-1 w-full border-gray-300 py-[5px] px-2 font-semibold rounded-lg placeholder:text-sm"
                type="text"
                value={user?.address?.provinceId}
                disabled={loading}
                onChange={(e) => {
                  setUser((prevState) => ({
                    ...prevState,
                    address: {
                      ...prevState.address,
                      provinceId: e.target.value,
                    },
                  }));
                }}
                placeholder="จังหวัด (ตามบัตรปชช)"
              >
                <option key="">-</option>
                {constant.provinces.map((roundDate) => (
                  <option key={roundDate} value={roundDate}>
                    {roundDate}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div>
            <p className="font-semibold text-sm text-gray-500">
              รหัสไปรษณีย์ (ตามบัตรปชช)
            </p>
            <div className="flex">
              <input
                className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
                type="text"
                value={user?.address?.zipcodeId}
                disabled={loading}
                onChange={(e) => {
                  setUser((prevState) => ({
                    ...prevState,
                    address: {
                      ...prevState.address,
                      zipcodeId: e.target.value,
                    },
                  }));
                }}
                placeholder="รหัสไปรษณีย์ (ตามบัตรปชช)"
              />
            </div>
          </div>
          <div
            className={`${
              user?.activated ? "bg-green" : "bg-gray-300"
            } text-white rounded-md flex mx-auto items-center hover:opacity-85 duration-150 h-fit mt-auto w-56 px-3 py-2.5 gap-3 cursor-pointer`}
            onClick={() =>
              setUser((prevState) => ({
                ...prevState,
                activated: !user.activated,
              }))
            }
          >
            <div className="">
              <Switch
                checked={user?.activated}
                onCheckedChange={async (e) => {
                  setUser((prevState) => ({
                    ...prevState,
                    activated: e,
                  }));
                }}
              />
            </div>
            <p className="font-semibold text-sm">ยืนยัน OTP แล้ว</p>
          </div>
          <div>
            <p className="font-semibold text-sm text-gray-500">เบอร์โทรศัพท์</p>
            <div className="flex">
              <input
                className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
                type="text"
                disabled={loading}
                value={user?.phone}
                onChange={(e) => {
                  setUser((prevState) => ({
                    ...prevState,
                    phone: e.target.value,
                  }));
                }}
                placeholder="เบอร์โทรศัพท์"
              />
            </div>
          </div>
          <div>
            <p className="font-semibold text-sm text-gray-500">อีเมล์</p>
            <div className="flex">
              <input
                className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
                type="text"
                disabled={loading}
                value={user?.email}
                onChange={(e) => {
                  setUser((prevState) => ({
                    ...prevState,
                    email: e.target.value,
                  }));
                }}
                placeholder="อีเมล์"
              />
            </div>
          </div>
          <div></div>
          <div>
            <p className="font-semibold text-sm text-gray-500">สัญชาติ</p>
            <div className="flex">
              <select
                className="border-1 w-full border-gray-300 py-[5px] px-2 font-semibold rounded-lg placeholder:text-sm"
                type="text"
                disabled={loading}
                value={user?.nationality}
                onChange={(e) => {
                  // handleInputChange("nationality", e.target.value);
                }}
                placeholder="จังหวัด"
              >
                <option value="">-</option>
                <option value="TH">ไทย</option>
                <option value="LAO">ลาว</option>
              </select>
            </div>
          </div>
          <div>
            <p className="font-semibold text-sm text-gray-500">วันเกิด </p>

            <DatePicker
              className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
              locale={buddhistLocale}
              value={user?.dob ? dayjs(user?.dob, "YYYY-MM-DD") : false}
              disabled={loading}
              onChange={(en, th) => {
                const selectedDate =
                  th.split("-")[2] -
                  543 +
                  "-" +
                  th.split("-")[1] +
                  "-" +
                  th.split("-")[0];
                // handleInputChange("dob", selectedDate);

                setUser((prevState) => ({
                  ...prevState,
                  dob: selectedDate,
                }));
              }}
            />
          </div>
          <div></div>
          <div>
            <p className="font-semibold text-sm text-gray-500">ขื่อไลน์</p>
            <div className="flex">
              <input
                className="border-1 w-full border-gray-300 py-1.5 px-2  rounded-lg placeholder:text-sm"
                type="text"
                onChange={(e) => {
                  setUser((prevState) => ({
                    ...prevState,
                    lineTitle: e.target.value,
                  }));
                }}
                defaultValue={user?.lineTitle}
                placeholder="ขื่อไลน์"
              />
            </div>
          </div>
          <div>
            <p className="font-semibold text-sm text-gray-500">ไอดีไลน์</p>
            <div className="flex">
              <input
                className="border-1 w-full border-gray-300 py-1.5 px-2 rounded-lg placeholder:text-sm"
                type="text"
                onChange={(e) => {
                  setUser((prevState) => ({
                    ...prevState,
                    lineId: e.target.value,
                  }));
                }}
                // onChange={(e) => {
                //   handleInputChange("lineId", e.target.value);
                // }}
                defaultValue={user?.lineId}
                placeholder="ไอดีไลน์"
              />
            </div>
          </div>
          <div></div>
          <div className="col-span-2">
            <p className="font-semibold text-sm text-gray-500">
              ที่อยู่ (จัดส่ง)
            </p>
            <div className="flex">
              <textarea
                className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
                type="text"
                defaultValue={user?.address?.addr}
                disabled={loading}
                // onChange={(e) => {
                //   handleInputChange("address.addrId", e.target.value);
                // }}
                // onBlur={(e) => updateUser("address.addrId", e.target.value)}
                placeholder="ที่อยู่"
              />
            </div>
          </div>
          <div></div>
          <div>
            <p className="font-semibold text-sm text-gray-500">
              จังหวัด (จัดส่ง)
            </p>
            <div className="flex">
              <select
                className="border-1 w-full border-gray-300 py-[5px] px-2 font-semibold rounded-lg placeholder:text-sm"
                type="text"
                defaultValue={user?.address?.province}
                disabled={loading}
                onChange={(e) => {
                  setUser((prevState) => ({
                    ...prevState,
                    address: { ...prevState.address, province: e.target.value },
                  }));
                }}
                // onChange={(e) => {
                //   updateUser("address.provinceId", e.target.value);
                // }}
                // onChange={(e) => {
                //   handleInputChange("address.provinceId", e.target.value);
                // }}
                placeholder="จังหวัด (จัดส่ง)"
              >
                <option key="">-</option>
                {constant.provinces.map((roundDate) => (
                  <option key={roundDate} value={roundDate}>
                    {roundDate}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div>
            <p className="font-semibold text-sm text-gray-500">
              รหัสไปรษณีย์ (จัดส่ง)
            </p>
            <div className="flex">
              <input
                className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
                type="text"
                defaultValue={user?.address?.zipcode}
                disabled={loading}
                onChange={(e) => {
                  setUser((prevState) => ({
                    ...prevState,
                    address: { ...prevState.address, zipcode: e.target.value },
                  }));
                }}
                // onChange={(e) => {
                //   handleInputChange(
                //     "address.zipcodeId",
                //     e.target.value.replaceAll(" ", "")
                //   );
                // }}
                placeholder="รหัสไปรษณีย์ (จัดส่ง)"
              />
            </div>
          </div>

          <div></div>
          <div className="col-span-2">
            <p className="font-semibold text-sm text-gray-500">ธนาคาร</p>
            <div className="flex">
              <select
                className="border-1 w-full border-gray-300 py-[5px] px-2 font-semibold rounded-lg placeholder:text-sm"
                type="text"
                defaultValue={user?.address?.province}
                disabled={loading}
                onChange={(e) => {
                  setUser((prevState) => ({
                    ...prevState,
                    bank: { ...prevState.bank, name: e.target.value },
                  }));
                }}
              >
                <option key="">-</option>
                {constant.bankList.map((bank) => (
                  <option key={bank.bankName} value={bank.bankName}>
                    {bank.bankName}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div></div>
          <div>
            <p className="font-semibold text-sm text-gray-500">ชื่อบัญชี</p>
            <div className="flex">
              <input
                className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
                type="text"
                defaultValue={user?.bank?.accName}
                disabled={loading}
                onChange={(e) => {
                  setUser((prevState) => ({
                    ...prevState,
                    bank: { ...prevState.bank, accName: e.target.value },
                  }));
                }}
                placeholder="ชื่อบัญชี"
              />
            </div>
          </div>
          <div>
            <p className="font-semibold text-sm text-gray-500">เลขที่บัญชี</p>
            <div className="flex">
              <input
                className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
                type="text"
                defaultValue={user?.bank?.accNo}
                disabled={loading}
                onChange={(e) => {
                  setUser((prevState) => ({
                    ...prevState,
                    bank: { ...prevState.bank, accNo: e.target.value },
                  }));
                }}
                placeholder="เลขที่บัญชี"
              />
            </div>
          </div>

          <div className="border-t border-[#E5E7E9] col-span-3 mt-2 pt-3">
            <button
              className="w-full py-2 rounded-md bg-blue text-white text-center font-semibold hover:opacity-65 duration-150"
              disabled={loading}
              onClick={() => createUser()}
            >
              สร้างบัญชีผู้ใช้ใหม่
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
